import {getReq} from '../api/restHelper'
import store from '../store'
import moment from 'moment'
import momentJalaali from 'moment-jalaali';
import { checkRecordInList, calculateDuration } from '../api/timeListProcess'

export function updateRecordsOfMainPage(list,daysN){
    let period_start = momentJalaali({hour : 0, minute : 0, second: 0}).startOf('jMonth').locale('en').format('YYYY-MM-DDTHH:mm:ss');
    period_start = moment(period_start,'YYYY-MM-DDTHH:mm:ss');
    const pageList = []
    for(let time of list){
        let diff = moment(time.start).diff(period_start,'days',true)
        if( diff >= 0){
            pageList.push(time)
        }
    }

    let recordsDuration = calculateDuration(pageList);
    store.dispatch({ type : 'SET_RECORDS_OF_WEEK', payload:pageList })
    store.dispatch({ type : 'SET_RECORDS_TOTAL_DURATIN', payload:recordsDuration })
}

export function getWsRecords (onSuccess = (res)=>{}, onErorr = (res)=>{}){

    const state = store.getState();
    if( !state.timer.getWsRecords_running ){

        store.dispatch({ type : 'CHANGE_GET_WS_RECORD_RUNNING', payload: true })
        const now = state.app.start_date;
        const end = state.app.end_date;
        const getRecordsUrl = 'record?start=' + now + '&end=' + end + '&workspace=' + store.getState().app.work_space.id + '&per_page=-1'

        getReq(getRecordsUrl, (res)=>{
            store.dispatch({ type : 'CHANGE_GET_WS_RECORD_RUNNING', payload: false })
            store.dispatch({ type : 'PUSH_RECORD_LIST', payload:res.data })
            let daysN = state.app.display_duration;
            updateRecordsOfMainPage(res.data.list,daysN);
            if(state.app.main_loading){
                store.dispatch({ type : 'STOP_MAIN_APP_LOADING', payload:{}})
            }
            onSuccess(res)
        }, (res)=>{
            store.dispatch({ type : 'CHANGE_GET_WS_RECORD_RUNNING', payload: false })
            onErorr(res)
        }, false, false );
    }
}

function getMainRecord(){
    getReq('record/active', (res) =>{
        store.dispatch({ type:'SET_ACTIVE_RECORD', payload:res.data })
        getWsRecords()

    }, ()=>{
        getWsRecords();
    }, false, false)
}

// a copy of this function exists in actions/project.js
function fetchMainDataFunction () {
    if(!localStorage.work_space){
        getReq('workspace?page=1&per_page=-1',(res)=>{
            store.dispatch({ type:'SET_WORKSPACE', payload:res.data.list[0] })
            localStorage.work_space = res.data.list[0].id;
            getMainRecord();
        }, ()=>{},false,false );
    }
    else{
        let storageData = localStorage.work_space;
        getReq( 'workspace/' + storageData , (res)=>{
            store.dispatch({ type:'SET_WORKSPACE', payload:res.data})
            localStorage.work_space = res.data.id;
            getMainRecord();
        }, ()=>{ localStorage.removeItem("work_space"); fetchMainDataFunction(); },false,false );
    }
}

export function changeWs (ws){
    return function(dispatch, getState){
        dispatch({ type:'SET_WORKSPACE', payload: ws })
        localStorage.work_space = ws.id;
        dispatch({ type : 'START_MAIN_APP_LOADING', payload:{}})
        getMainRecord();
    }
}

export function changeLoginStatus(newStatus) {
    return {
        type: "CHANGE_LOGIN_STATUS",
        payload: newStatus
    }
}

export function addLoading() {
    return {
        type: "ADD_LOADING",
        payload: {}
    }
}

export function removeLoading() {
    return {
        type: "REMOVE_LOADING",
        payload: {}
    }
}

export function addPhoneNumber(phone) {
    return {
        type: "ADD_PHONE_NUMBER",
        payload: phone
    }
}

export function fetchMainData() {
    return function(dispatch){
        getReq('workspace', (res)=>{
            fetchMainDataFunction()
        }, (res)=>{}, false, false)
    }
}

export function updateDatetime(datetime) {
        store.dispatch({ type : 'UPDATE_DATETIME', payload: datetime })
}

export function changeSocketStatus(status){
    return {
        type: "CHANGE_SOCKET_STATUS",
        payload: status
    }
}

export function creatSocketRecord(data) {
    return function(dispatch, getState){
        const state = getState();
        if( data.end ){
            if(!checkRecordInList(state.timer.records.list, data)){
                getWsRecords();
            }
        }else{
            // active record
            if( !state.timer.timer_loading && state.timer.active_record.id !== data.id){
                dispatch({ type:'SET_ACTIVE_RECORD', payload:data});
                getWsRecords();
            }
        }
        
    }
}

export function updateSocketRecord(data) {
    return function(dispatch, getState){
        const state = getState();
        if( data.end ){
            if( state.timer.active_record.id && state.timer.active_record.id === data.id ){
                dispatch({type:'REMOVE_ACTIVE_RECORD', payload: {}});
            }
            if( !checkRecordInList(state.timer.records.list, data) ){
                getWsRecords();
            }
        }else{
            dispatch({ type:'SET_ACTIVE_RECORD', payload:data});
        }
    }
}

export function deleteSocketRecord(data) {
    return function(dispatch, getState){
        const state = getState();
        if( data.end ){
            if( checkRecordInList(state.timer.records.list, data) ){
                getWsRecords();
            }
        }else if(state.timer.active_record.start){
            dispatch({ type:'REMOVE_ACTIVE_RECORD', payload:data});
        }
    }
}